/**
 * Resolves the Administration → My School menu item.
 *
 * The navigation YAML lists "My School" at /my-school, but every school-edit
 * surface is keyed on the school's id (/schools/:id/edit). This route reads
 * the current user's school from the auth context and forwards to the
 * existing SchoolEditForm so admins / school admins reach a real page
 * instead of the silent 404 the missing route used to produce.
 *
 * Edge cases:
 *  - No school on the auth payload (e.g. a Django superuser without a
 *    Teacher row): redirect to /schools (the list page) and let them pick.
 *  - User not loaded yet: render nothing so the redirect waits for auth.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const MySchoolRedirect: React.FC = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  const schoolId = user?.user_profile?.teacher_profile?.school?.id;
  if (!schoolId) return <Navigate to="/schools" replace />;
  return <Navigate to={`/schools/${schoolId}/edit`} replace />;
};

export default MySchoolRedirect;
